class LocalStorage {
	static getItem(key) {
		const value = window.localStorage.getItem(key);
		let jsonValue = '';
		try {
			jsonValue = JSON.parse(value);
		} finally {
			return value ? jsonValue || value : null;
		}
	}

	static setItem(key, value) {
	  	window.localStorage.setItem(key, value !== '' ? JSON.stringify(value) : '');
	}

	static removeItem(key) {
	  	window.localStorage.removeItem(key);
	}
}
export default LocalStorage;